import {
  BOOKS_BOOK_FRAGMENT_SET_DATA,
  BOOKS_BOOK_FRAGMENT_RESET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  book: null,
  fragment: null,
  pageNumber: 1,
  lastPageNumber: 0,
};

export default function bookFragment(state = initialState, action) {
  switch (action.type) {
    case BOOKS_BOOK_FRAGMENT_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_BOOK_FRAGMENT_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
